import { useTranslate } from '../../hooks'
import { handleNumericInput, handlePasteInput } from '@repo/tools'
import {
  formatNumberWithCommas,
  removeCommasFromNumber,
} from '@repo/tools/src/convert'
import { Col, Input, InputNumericStepper } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import type { AdvancedTradeBoxAmountInputProps } from './advanced-trade-box.types'

export const AdvancedTradeBoxAmountInput = ({
  value,
  onChange,
  max,
  assetLabel = 'cm²',
  label,
  onAmountChange,
}: AdvancedTradeBoxAmountInputProps) => {
  const isDesktop = useIsDesktop()
  const { t } = useTranslate()

  return (
    <Col className='gap-xs'>
      {label && isDesktop && (
        <span className='font-bold text-xs text-neutral-surface-80'>
          {label}
        </span>
      )}
      {isDesktop ? (
        <Input
          value={formatNumberWithCommas(Number(value.toFixed(2)))}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            const newValue = Number(cleanValue) || 0
            onChange(newValue)
            onAmountChange?.(newValue)
          }}
          min={0}
          max={max}
          endLabel={assetLabel}
          inputSize='md'
          onKeyDown={(e) => handleNumericInput(e, 10, /[0-9۰-۹٠-٩]/, max)}
          onPaste={(e) => handlePasteInput(e, 10, /[0-9۰-۹٠-٩]/, max)}
          itemType='text'
          className='flex-1'
          title={t('common_cm2')}
        />
      ) : (
        <InputNumericStepper
          value={formatNumberWithCommas(Number(value.toFixed(2)))}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            const newValue = Number(cleanValue) || 0
            onChange(newValue)
            onAmountChange?.(newValue)
          }}
          min={0}
          max={max}
          step={1}
          inputSize='sm'
          onKeyDown={(e) => handleNumericInput(e, 10, /[0-9۰-۹٠-٩]/, max)}
          onPaste={(e) => handlePasteInput(e, 10, /[0-9۰-۹٠-٩]/, max)}
          itemType='text'
          className='w-full ltr'
          placeholder={t('common_cm2')}
        />
      )}
    </Col>
  )
}
